import { Route, RouteRecord } from 'vue-router'

export function getFeaturesFromRoute(to: Route) {
  const features: Array<Array<string>> = to.matched.reduce((prev: any, current: RouteRecord) => {
    const { pageFeatures } = current?.meta ?? {}
    return (pageFeatures ? [...prev, Array.isArray(pageFeatures) ? pageFeatures : [pageFeatures]] : prev)
  }, [])
  return features
}

export function isPageHasFeatures(features: Array<Array<string>>, featuresChecker: Function) {
  for (let i = 0; i < features.length; i += 1) {
    const pageFeatures = features[i]
    const isFailed = !pageFeatures.some((feature: string) => featuresChecker(feature))
    if (isFailed) {
      return false
    }
  }
  return true
}
